let stripe, customer, price, card

export const InitCheckout = {
  mounted() {
    const paymentMethodCreatedCallback = (paymentMethod) => {
      this.pushEvent("payment-method-created", paymentMethod)
    }

    const isLoadingByCard = (loadingState) => {
      this.pushEvent("is-loading", { loading: loadingState, type: "card" })
    }

    const isLoadingByCheckout = (loadingState) => {
      this.pushEvent("is-loading", { loading: loadingState, type: "checkout" })
    }

    init(this.el, {
      paymentMethodCreatedCallback,
      isLoadingByCheckout,
      isLoadingByCard,
    })

    this.handleEvent("requires_action", (data) => {
      requireCustomerAction({
        clientSecret: data.client_secret,
        paymentMethodId: data.payment_method_id,
        isLoadingByCard: isLoadingByCard,
        isLoadingByCheckout: isLoadingByCheckout,
      })
    })
  },
}

const init = (
  form,
  { paymentMethodCreatedCallback, isLoadingByCard, isLoadingByCheckout },
) => {
  stripe = Stripe(form.dataset.publicKey)
  let elements = stripe.elements()
  card = elements.create("card", { style: style })

  card.mount("#card-element")

  card.on("change", (event) => {
    displayError(event)
  })

  card.on("focus", (event) => {
    displayError(event)
  })

  // Handle form submission.
  form.addEventListener("submit", (event) => {
    event.preventDefault()
    isLoadingByCard(true)
    createPaymentMethod({
      card,
      paymentMethodCreatedCallback,
      isLoadingByCard,
    })
  })

  document.getElementById("pay").addEventListener("click", function (evt) {
    evt.preventDefault()

    let priceId = document.getElementById("pay").dataset.priceId
    let customerId = document.getElementById("pay").dataset.customerId

    isLoadingByCheckout(true)

    createCheckoutSession(priceId, customerId).then(function (data) {
      // Call Stripe.js method to redirect to the new Checkout page
      stripe
        .redirectToCheckout({
          sessionId: data.session_id,
        })
        .then(handleResult)
    })
  })
}

function createPaymentMethod({
  card,
  paymentMethodCreatedCallback,
  isLoadingByCard,
}) {
  const billingName = document.querySelector("#card-name").value

  stripe
    .createPaymentMethod({
      type: "card",
      card: card,
      billing_details: {
        name: billingName,
      },
    })
    .then((result) => {
      if (result.error) {
        isLoadingByCard(false)
        displayError(result)
      } else {
        paymentMethodCreatedCallback(result.paymentMethod)
      }
    })
}

const requireCustomerAction = ({
  clientSecret,
  paymentMethodId,
  isLoading,
}) => {
  stripe
    .confirmCardPayment(clientSecret, { payment_method: paymentMethodId })
    .then((result) => {
      isLoading(false)

      if (result.error) {
        // start code flow to handle updating the payment details
        // Display error message in your UI.
        // The card was declined (i.e. insufficient funds, card has expired, etc)
        throw result
      }
    })
}

const displayError = (event) => {
  const displayError = document.getElementById("card-errors")
  if (event.error) {
    displayError.textContent = event.error.message
  } else {
    displayError.textContent = ""
  }
}

// Custom styling can be passed to options when creating an Element.
// (Note that this demo uses a wider set of styles than the guide below.)
const style = {
  base: {
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
}

// If a fetch error occurs, log it to the console and show it in the UI.
var handleFetchResult = function (result) {
  if (!result.ok) {
    return result
      .json()
      .then(function (json) {
        if (json.error && json.error.message) {
          throw new Error(
            result.url + " " + result.status + " " + json.error.message,
          )
        }
      })
      .catch(function (err) {
        showErrorMessage(err)
        throw err
      })
  }
  return result.json()
}

// Create a Checkout Session with the selected plan ID
var createCheckoutSession = function (priceId, customerId) {
  return fetch("/stripe/create_session", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      _csrf_token: document.getElementsByName("csrf-token")[0].content,
      priceId: priceId,
      customerId: customerId,
    }),
  }).then(handleFetchResult)
}

// Handle any errors returned from Checkout
var handleResult = function (result) {
  if (result.error) {
    showErrorMessage(result.error.message)
  }
}

var showErrorMessage = function (message) {
  var errorEl = document.getElementById("error-message")
  errorEl.textContent = message
  errorEl.style.display = "block"
}
